function eventName(_event: string) {
  return "on" + _event[0].toUpperCase() + _event.substr(1);
}

let _eventListener: any = null;

export class Listener {
  static add(_property: string, _handler: any) {
    // _property = eventName(_property);
    // let winformObj = ((parent.window || window) as any)["md"] || {};
    let winformObj = ((parent.window || window) as any);
    if (!winformObj[_property]) {
      winformObj[_property] = _handler;
    } else {
      const oldHandler = winformObj[_property];
      winformObj[_property] = (args: any) => {
        oldHandler(args);
        _handler(args);
      }
    }
    return true;
  }

  static remove(_property: string) {
    // _property = eventName(_property);
    return delete ((parent.window || window) as any)[_property];
  }

  static bodyEventDelegate(whiteList: string[] = [], boundaryName = 'body', fn: (obj: any) => {} ) {
    _eventListener = function(e: { target: { className: string; dataset: { value: any; }; }; }) {
      //针对不同浏览器的解决方案
      const eventObj = { className: e.target.className, type: 'default', dataset: e.target.dataset };
      function matchesSelector(element: any, selector: any){
        if(element.matches){
          return element.matches(selector);
        } else if(element.matchesSelector){
          return element.matchesSelector(selector);
        } else if(element.webkitMatchesSelector){
          return element.webkitMatchesSelector(selector);
        } else if(element.msMatchesSelector){
          return element.msMatchesSelector(selector);
        } else if(element.mozMatchesSelector){
          return element.mozMatchesSelector(selector);
        } else if(element.oMatchesSelector){
          return element.oMatchesSelector(selector);
        }
      }
      if (whiteList.includes(e.target.className)) {
        eventObj.type = 'white_click';
      }
      if(!matchesSelector(e.target, `.${boundaryName} *`)){
        eventObj.type = 'out_click';
      }
      fn(eventObj);
    };
    // 弹框列表出现后，点击其他任意位置，弹框缩回
    (document as any).querySelector('body').removeEventListener('click', _eventListener, false);
    (document as any).querySelector('body').addEventListener('click', _eventListener, false);
  }
}
